import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser, resetVersion } from '../../store/userSlice';
import { UserMenu } from './UserMenu';
import releasenotes from './releasenotes.json';
import { AboutModal } from './AboutModal';
import { getCurrentAppVersion } from '../../utils';
import { updateUserVersion } from '../../store/api/users';
import { VersionNotification } from './VersionNotification';
import { setNotification } from '../../store/notificationsSlice';
import keycloak from '../../Keycloak';

const UserMenuContainer = (props) => {
    const dispatch = useDispatch();
    const { version } = useSelector(state => state.user);
    const { fullName, defaultOrgName, grant, orgAlias, canImpersonate, lastSeenVersion } = useSelector(state => state.user.grants);
    const { notes, notifications } = releasenotes;
    const latestRelease = notes.at(-1).version;
    let currentVersion = null, notesList = notes.slice();
    if (process.env.REACT_APP_BUILD > 0) {
        currentVersion = getCurrentAppVersion();
        notesList.push({ version: currentVersion });
    };

    useEffect(() => {
        if (!fullName) {
            dispatch(getCurrentUser());
        }
    }, [ fullName ]);

    useEffect(() => {
        if (lastSeenVersion != null && lastSeenVersion < latestRelease) {
            setVisible("release");
            if (Array.isArray(notifications[latestRelease]) && notifications[latestRelease].length) {
                notifications[latestRelease].map(notification => dispatch(setNotification({ message: notification, closable: false })));
            }
        }
    }, [ lastSeenVersion ]);

    const [visible, setVisible] = useState(false);
    const [selected, selectItem] = useState(notesList.at(-1).version);

    const handleMenuClick = (key) => {
        if (key == 0) {
            keycloak.login({ action: "UPDATE_PASSWORD" });
        } else if (key == 1) {
            setVisible("notes");
        }
    };

    const onRefresh = (e) => {
        e.preventDefault();
        document.location.reload();
    };

    const onUpdateUserVersion = (visible) => {
        dispatch(updateUserVersion(latestRelease));
        setVisible(visible);
    };

    return(grant
        ? <>
            <UserMenu
                name={fullName}
                orgName={defaultOrgName}
                grant={grant}
                orgAlias={orgAlias}
                canImpersonate={canImpersonate}
                handleMenuClick={handleMenuClick}
            />
           {visible == "notes" && <AboutModal
                visible={visible == "notes"}
                onClose={() => setVisible(false)}
                notes={notesList}
                selected={selected}
                onItemSelect={(key) => selectItem(key)}
                currentVersion={currentVersion || latestRelease}
            />}
            {version || visible == "release"
                ? createPortal(
                    <VersionNotification
                        version={version}
                        lastVersion={latestRelease}
                        onRefresh={onRefresh}
                        onClose={() => version ? dispatch(resetVersion()) : onUpdateUserVersion(false)}
                        onShowReleaseNotes={() => onUpdateUserVersion("notes")}
                    />,
                    document.getElementById("sp-front-panel")
                )
            : null}
        </>
        : null
    )
};

export { UserMenuContainer };
